import Vue from 'vue'

export default {
  state: {
    overview: null,
    logs: {
      items: [],
      count: null
    },
    reserve: {
      items: [],
      count: null
    },
    sweepCandidates: [],
    sweepStatus: {
      run: null,
      logs: []
    },
    bep20SweepCandidates: [],
    bep20SweepStatus: {
      run: null,
      logs: []
    },
    // Вывод с газом с отдельного кошелька: Ethereum (ERC20), Polygon, Arbitrum, TON
    evmSweep: {
      erc20: { candidates: [], status: { run: null, logs: [] }, gas: null },
      polygon: { candidates: [], status: { run: null, logs: [] }, gas: null },
      arb: { candidates: [], status: { run: null, logs: [] }, gas: null },
      ton: { candidates: [], status: { run: null, logs: [] }, gas: null },
      btc: { candidates: [], status: { run: null, logs: [] }, gas: null }
    },
    solSweepCandidates: [],
    solSweepStatus: {
      run: null,
      logs: []
    },
    balanceCheckStatus: {
      run: null
    }
  },
  mutations: {
    setGodOverview (state, overview) {
      Vue.set(state, 'overview', overview)
    },
    setGodLogs (state, logs) {
      Vue.set(state, 'logs', logs)
    },
    setGodReserve (state, reserve) {
      Vue.set(state, 'reserve', reserve)
    },
    setGodSweepCandidates (state, items) {
      Vue.set(state, 'sweepCandidates', items || [])
    },
    setGodSweepStatus (state, status) {
      Vue.set(state, 'sweepStatus', status || { run: null, logs: [] })
    },
    setGodBep20SweepCandidates (state, items) {
      Vue.set(state, 'bep20SweepCandidates', items || [])
    },
    setGodBep20SweepStatus (state, status) {
      Vue.set(state, 'bep20SweepStatus', status || { run: null, logs: [] })
    },
    setGodEvmSweep (state, { network, field, value }) {
      Vue.set(state.evmSweep[network], field, value)
    },
    setGodSolSweepCandidates (state, items) {
      Vue.set(state, 'solSweepCandidates', items || [])
    },
    setGodSolSweepStatus (state, status) {
      Vue.set(state, 'solSweepStatus', status || { run: null, logs: [] })
    },
    setGodBalanceCheckStatus (state, status) {
      Vue.set(state, 'balanceCheckStatus', status || { run: null })
    }
  },
  actions: {
    async getGodOverview (ctx) {
      const res = await Vue.$api.getGodOverview()
      ctx.commit('setGodOverview', res?.data)
      return res?.data
    },
    async recheckGodRotation (ctx) {
      const res = await Vue.$api.godRecheckRotation()
      ctx.commit('setGodOverview', res?.data)
      return res?.data
    },
    async getGodLogs (ctx, params) {
      const res = await Vue.$api.getGodLogs({ params })
      ctx.commit('setGodLogs', res?.data)
      return res?.data
    },
    async getGodReserve (ctx, params) {
      const res = await Vue.$api.getGodReserve({ params })
      ctx.commit('setGodReserve', res?.data)
      return res?.data
    },
    async getGodSweepCandidates (ctx) {
      const res = await Vue.$api.getGodSweepCandidates()
      ctx.commit('setGodSweepCandidates', res?.data)
      return res?.data
    },
    async startGodSweep (ctx, params) {
      const res = await Vue.$api.startGodSweep({ data: params })
      return res?.data
    },
    async getGodSweepStatus (ctx, params) {
      const res = await Vue.$api.getGodSweepStatus({ params })
      ctx.commit('setGodSweepStatus', res?.data)
      return res?.data
    },
    async getGodBep20SweepCandidates (ctx) {
      const res = await Vue.$api.getGodBep20SweepCandidates()
      ctx.commit('setGodBep20SweepCandidates', res?.data)
      return res?.data
    },
    async startGodBep20Sweep () {
      const res = await Vue.$api.startGodBep20Sweep()
      return res?.data
    },
    async getGodBep20SweepStatus (ctx, params) {
      const res = await Vue.$api.getGodBep20SweepStatus({ params })
      ctx.commit('setGodBep20SweepStatus', res?.data)
      return res?.data
    },
    async getGodBep20Leftovers () {
      const res = await Vue.$api.getGodBep20Leftovers()
      return res?.data
    },
    async startGodBep20Leftovers () {
      const res = await Vue.$api.startGodBep20Leftovers()
      return res?.data
    },
    async getGodEvmSweepCandidates (ctx, network) {
      const res = await Vue.$api.getGodEvmSweepCandidates({ segments: { network } })
      ctx.commit('setGodEvmSweep', { network, field: 'candidates', value: res?.data || [] })
      return res?.data
    },
    async getGodEvmGas (ctx, network) {
      const res = await Vue.$api.getGodEvmGas({ segments: { network } })
      ctx.commit('setGodEvmSweep', { network, field: 'gas', value: res?.data || null })
      return res?.data
    },
    async startGodEvmSweep (ctx, network) {
      const res = await Vue.$api.startGodEvmSweep({ segments: { network } })
      return res?.data
    },
    async getGodEvmSweepStatus (ctx, { network, runId }) {
      const res = await Vue.$api.getGodEvmSweepStatus({ segments: { network }, params: runId ? { runId } : {} })
      ctx.commit('setGodEvmSweep', { network, field: 'status', value: res?.data || { run: null, logs: [] } })
      return res?.data
    },
    async getGodSolSweepCandidates (ctx) {
      const res = await Vue.$api.getGodSolSweepCandidates()
      ctx.commit('setGodSolSweepCandidates', res?.data)
      return res?.data
    },
    async startGodSolSweep () {
      const res = await Vue.$api.startGodSolSweep()
      return res?.data
    },
    async getGodSolSweepStatus (ctx, params) {
      const res = await Vue.$api.getGodSolSweepStatus({ params })
      ctx.commit('setGodSolSweepStatus', res?.data)
      return res?.data
    },
    async startGodBalanceCheck () {
      const res = await Vue.$api.startGodBalanceCheck()
      return res?.data
    },
    async getGodBalanceCheckStatus (ctx) {
      const res = await Vue.$api.getGodBalanceCheckStatus()
      ctx.commit('setGodBalanceCheckStatus', res?.data)
      return res?.data
    }
  }
}
